/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ age: NonNullable<unknown> }} Guardian_Child_AgeInputs */

const fr_guardian_child_age = /** @type {(inputs: Guardian_Child_AgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.age} ans`)
};

/**

* @param {Guardian_Child_AgeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const guardian_child_age = /** @type {((inputs: Guardian_Child_AgeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardian_Child_AgeInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_guardian_child_age(inputs)
});